import { API, Card, Explination, Help, InfoBox, Output, SearchModal, Table, ViewHeader } from '@enkla-gui'
import React, { useEffect, useState } from 'react'
import { cashmoneyhelper, date, notify } from '@/_helpers'
import { useHistory, useParams } from 'react-router-dom'

import sv from 'date-fns/locale/sv'
import Addons from '@components/lease/Addons'
import Agreements from '@components/lease/Agreements'
import DatePicker from 'react-datepicker'
import EntityInfo from '@components/entity/EntityInfo'
import Events from '@components/tools/Events'
import Files from '@components/tools/Files'
import Invoices from '@components/lease/Invoices'
import LeaseQuittances from '@components/lease/Quittances'
import Modal from 'react-modal'
import { icons } from '@config'
import moment from 'moment'

export default function Lease() {
  let { id } = useParams()
  let [lease, setLease] = useState(false)
  let [searchModal, setSearchModal] = useState(false)
  let [modal, setModal] = useState(false)
  let [error, setError] = useState(false)
  const [refresh, setRefresh] = useState(false)
  let [sending, setSending] = useState(false)
  let [endDate, setEndDate] = useState()
  let [nextInvoiceMonth, setNextInvoiceMonth] = useState(false)
  let [invoiceMonthModal, setInvoiceMonthModal] = useState(false)
  let [infoModal, setInfoModal] = useState(false)
  let [entityInfoModal, setEntityInfoModal] = useState(false)
  let [unreturnedQuittances, setUnreturnedQuittances] = useState(0)
  let [showInc, setShowInc] = useState(false)
  const history = useHistory()

  useEffect(() => {
    getLease()
  }, [id])

  const getLease = () => {
    API.get(`api/lease/${id}`).then(lease => {
      setLease(lease)
      setEndDate(lease.stop)
      if (lease.next_invoice_month === null) return setNextInvoiceMonth(null)
      const next = moment(lease.next_invoice_month, "YYYY-MM");
      const next_based = moment(lease.next_invoice_month_based_on_invoicingconfig, "YYYY-MM");
      const selectedMonth = next.isBefore(next_based) ? next_based : next;
      setNextInvoiceMonth(selectedMonth.format("YYYY-MM"));
    })
    setRefresh(date.now())
  }

  const make_primary = async (e, tenant) => {
    e.stopPropagation()
    e.preventDefault()
    if (!(await notify.confirm("Vill du göra denna hyresgäst till primär hyresgäst för uthyrningen?"))) return
    API.post(`api/lease/${id}/new_primary`, { tenant_id: tenant.id })
      .then(res => {
        notify.toast(`Primär hyresgäst har ändrats`)
        getLease()
      })
      .catch(([err, res]) => {
        notify.toast(res.message, 'error')
      })
  }

  const remove = async () => {
    if (!(await notify.confirm("Detta kommer att radera uthyrningen tillsammans med alla filer, hyresavier och hyreskontrakt. Denna åtgärd går inte att ångra"))) return
    API.delete(`api/lease/${id}`)
      .then(res => {
        notify.toast(`Uthyrning borttagen`)
        history.push(`/entity/${lease.entity_id}`)
      })
      .catch(([err, res]) => {
        notify.toast(`Borttagningen misslyckades: ${res.message}`, 'error')
      })
  }

  const convertInterval = interval => {
    switch (interval) {
      case 'MONTHLY':
        return 'Månadsvis'
      case 'QUARTERLY':
        return 'Kvartalsvis'
      case 'YEARLY':
        return 'Årligen'
      default:
        return 'Okänt'
    }
  }
  const convertNoticeType = type => {
    switch (type) {
      case 'DAY':
        return 'Dag(ar)'
      case 'MONTH':
        return 'Månad(er)'
      case 'YEAR':
        return 'År'
      default:
        return 'Okänt'
    }
  }

  const patch = (key, value) => {
    lease[key] = value
    setSending(true)
    API.patch('api/lease', lease)
      .then(res => {
        notify.toast(`Uthyrningen har uppdaterats`)
        getLease()
        setModal(false)
        setInvoiceMonthModal(false)
        setSending(false)
      })
      .catch(([err, res]) => {
        setError({
          message: res.message,
          data: res.data
        })
        notify.toast(res.message, 'error')
        setSending(false)
      })
  }

  const endsBeforeNextGen = () => {
    if (lease.stop === null) return false
    const nextInvoice = moment(
      lease.next_invoice_month_based_on_invoicingconfig,
      "YYYY-MM"
    );

    const generateDay = lease?.company?.invoicingconfig?.generate_day;
    const generatePeriod = lease?.company?.invoicingconfig?.generate_period;

    let nextGenDateTime = moment({
      year: nextInvoice.year(),
      month: nextInvoice.month(),
      day: generateDay,
    });

    if (generatePeriod === 'NEXT_MONTH') {
      nextGenDateTime.add(1, 'months');
    }

    const leaseEnd = moment.unix(lease.stop);
    return leaseEnd.isBefore(nextGenDateTime);
  };

  const getNextInvoiceAutoGenDate = () => {
    if (lease.next_invoice_month === null) return "Inaktiverat för denna uthyrning"
    if (endsBeforeNextGen()) return "Uthyrning upphör innan nästa generering"
    const nextInvoice = moment(lease.next_invoice_month_based_on_invoicingconfig, "YYYY-MM");
    const readable = nextInvoice.format("MMMM YYYY");
    const generateDay = lease?.company?.invoicingconfig?.generate_day;
    return generateDay + " " + readable
  }
  const getNextInvoicePeriod = () => {
    if (lease.next_invoice_month === null) return "Inaktiverat för denna uthyrning"
    if (endsBeforeNextGen()) return "Uthyrning upphör innan nästa generering"
    let date = moment(lease.next_invoice_month_based_on_invoicingconfig)
    if (lease?.company?.invoicingconfig?.generate_period === 'NEXT_MONTH') {
      date.add(1, 'months')
    }
    const start = date.locale('sv').format('MMMM YYYY')
    let interval = 0
    switch (lease.payment_interval) {
      case 'QUARTERLY':
        interval = 2
        break
      case 'YEARLY':
        interval = 11
        break
    }

    if (interval === 0) return start

    const end = date.clone().add(interval, 'months')
    return start + ' - ' + end.locale('sv').format('MMMM YYYY')
  }
  const addTenantToLease = (tenant) => {
    API.post('api/lease/tenant/relation', {
      lease_id: id,
      tenant_id: tenant._source.render.id
    }).then(res => {
      notify.toast('Hyresgästen har blivit tillagd', 'success')
      lease.tenants.push(tenant)
    }).catch(([err, res]) => {
      notify.toast(res.message, 'error')
    })
    setSearchModal(false)
    getLease()
  }
  const getMinSelectableDate = () => {
    const today = new Date();
    let minSelectableDate = new Date(today.getFullYear(), today.getMonth(), 1);
    const generateDay = lease?.company?.invoicingconfig?.generate_day;
    if (generateDay !== undefined && today.getDate() >= generateDay) {
      // Om generate_day redan passerat → hoppa till nästa månad
      minSelectableDate = new Date(today.getFullYear(), today.getMonth() + 1, 1);
    }
    return minSelectableDate
  }
  const detach = async (tenant) => {
    if (tenant.pivot.primary) return notify.toast('Kan inte koppla bort primär hyresgäst', 'warn')
    if (!await notify.confirm('Vill du ta bort ' + tenant.name + ' från denna uthyrning?')) return
    API.post(`api/lease/${id}/detach/${tenant.id}`).then(res => {
      notify.toast(`${tenant.name} borttagen från uthyrning`, 'success')
      getLease()
    }).catch(([err, res]) => {
      notify.toast(`Borttagningen misslyckades: ${res.message}`, 'error')
    })
  }

  const reactivate = async () => {
    if (!(await notify.confirm("Uthyrningen kommer ändras till pågående"))) return
    patch('stop', null)
  }

  return (
    <>
      <ViewHeader
        loading={!lease}
        icon='fa-key'
        title={`Uthyrning · ${lease?.entity?.name}`}
        subtitle={lease?.entity?.type.name}
        breadcrumbs={lease.breadcrumb}
        badges={[
          { bg: lease?.state?.color, text: lease?.state?.description || lease?.state?.title, icon: lease?.state?.icon },
          unreturnedQuittances > 0 && { bg: 'warning', text: `Oreturnerade kvittenser: ${unreturnedQuittances}`, icon: 'fas fa-key' }
        ].filter(Boolean)}
        buttons={[
          {
            icon: 'fa-calendar-times',
            title: lease.stop !== null ? 'Justera slutdatum' : 'Avsluta uthyrning',
            callback: () => setModal(true),
            hidden: lease?.state?.status === 'inactive'
          },
          {
            icon: 'fa-calendar',
            disabled: lease?.company?.invoicingconfig?.generate_day === null,
            tip: lease?.company?.invoicingconfig?.generate_day === null ? 'Hur ställer jag in automatisk hyresavisering?' : false,
            title: 'Justera nästa hyresaviperiod (autogenererade hyresavier)',
            callback: () => setInvoiceMonthModal(true),
            hidden: lease?.state?.status === 'inactive'
          },
          {
            icon: 'fa-envelope', title: 'Kontakta hyresgäster', href: `#!/contact/lease/${lease.id}`,
            hidden: lease?.state?.status === 'inactive'
          },
          {
            icon: 'fa-toggle-on', title: 'Återaktivera', callback: () => reactivate(),
            hidden: lease?.state?.status !== 'inactive'
          },
          { icon: icons.info, title: 'Information', callback: () => setInfoModal(true) },
          { icon: 'fa-trash-alt', title: 'Radera', callback: () => remove(), position: 'right' },
          {
            icon: 'fa-edit', title: 'Redigera', href: `#!/lease/${lease.id}/edit`, position: 'right',
            hidden: lease?.state?.status === 'inactive'
          }
        ]}
      />
      <div className='row'>
        <InfoBox
          loading={!lease}
          title='Uthyrt'
          subtitle={lease?.stop === null ? date.short(lease?.start) + ' - Tillsvidare' : date.short(lease?.start) + ' - ' + date.short(lease?.stop)}
          icon={lease?.state?.icon}
        />
        <InfoBox
          loading={!lease}
          click={_ => setShowInc(!showInc)}
          title={showInc ? 'Hyra (inkl. moms)' : 'Hyra (ex. moms)'}
          subtitle={`${cashmoneyhelper.format(showInc ? lease?.total_with_tax : lease?.total)} ${convertInterval(lease?.payment_interval).toLowerCase()}`}
          icon='fa-dollar-sign'
          explination='Hur beräknas hyran för min uthyrning?'
        />
      </div>
      <div class="row" hidden={lease?.state?.status === 'inactive'}>
        <InfoBox
          loading={!lease}
          title='Nästa hyresavi skapas automatiskt'
          subtitle={getNextInvoiceAutoGenDate()}
          hidden={lease?.company?.invoicingconfig?.generate_day === null}
          icon='fa-file-invoice'
          explination='Hur ställer jag in automatisk hyresavisering?'
        />
        <InfoBox
          loading={!lease}
          title='Nästa automatgenererade hyresavi avser period'
          subtitle={getNextInvoicePeriod()}
          hidden={lease?.company?.invoicingconfig?.generate_day === null}
          icon='fa-calendar'
          explination='Hur fungerar hyresintervallet på en uthyrning?'
        />
      </div>
      <Card title='Hyresgäster' icon='fas fa-fw fa-address-card' collapsed={lease.tenants?.length === 0}
        buttons={{
          header: [
            { link: `#!/lease/${id}/tenant/create`, icon: icons.create, text: 'Skapa', hidden: lease?.state?.status === 'inactive' },
            { callback: () => setSearchModal(true), icon: icons.link, text: 'Lägg till', hidden: lease?.state?.status === 'inactive' },
          ]
        }}
      >
        <Table rows={lease.tenants} link={`/#!/tenant/@{id}`} keys={['_this>function:primary', 'name', 'identifier', 'phone', 'email', '_this>button:detach:fa-unlink']}
          functions={{
            detach: (tenant) => detach(tenant),
            make_primary: (tenant) => make_primary(tenant),
            primary: (tenant) => tenant.pivot.primary ? <span class="badge bg-success">Primär hyresgäst {' '}
              <Explination tip='Vad innebär primär hyresgäst?' />
            </span> : <button hidden={lease?.state?.status === 'inactive'} onClick={e => make_primary(e, tenant)} class="btn btn-light btn-sm"><i class="fas fa-hospital-user"></i> Gör till primär</button>
          }}
        >
          <th className='min' />
          <th>Namn</th>
          <th>Pers/Org-nummer</th>
          <th>Telefon</th>
          <th>Epost</th>
          <th className='min' />
        </Table>
      </Card>
      <Invoices lease={lease} />
      <Agreements lease={lease} />
      {lease && <LeaseQuittances lease={lease} onUnreturnedCountChange={setUnreturnedQuittances} />}
      <Modal isOpen={infoModal} onRequestClose={() => setInfoModal(false)} className='no-padding'>
        <Card title='Uthyrning' icon='fas fa-key' loading={!lease}
          collapsed={null}
        >
          <div className='row mb-3'>
            <Output value={lease.reference} label='Avtalsreferens' />
            <Output value={convertInterval(lease.payment_interval)} label='Betalningsintervall' />
          </div>
          <div className='row mb-3'>
            <Output value={cashmoneyhelper.format(lease.fee)} label='Hyra (exmoms)' />
            <Output value={lease.tax_rate + '%'} label='Momssats(%)' />
          </div>
          <div className='row mb-3'>
            <Output value={date.short(lease.start)} label='Tillträde' />
            <Output value={!lease.stop ? 'Tillsvidare' : date.short(lease.stop)} label='Slutdatum' />
          </div>
          <div className='row mb-3'>
            <Output value={lease.notice_length} label='Uppsägningstid' />
            <Output value={convertNoticeType(lease.notice_type)} label='Enhet' />
          </div>
          <div className='row mb-3'>
            <Output value={date.full(lease.created_at)} label='Skapad' />
            <Output value={date.full(lease.updated_at)} label='Uppdaterad' />
          </div>
        </Card>
      </Modal>
      <Modal isOpen={entityInfoModal} onRequestClose={() => setEntityInfoModal(false)} className='no-padding'>
        <EntityInfo entity={lease.entity} />
      </Modal>
      <div class="row">
        <Files id={lease.id} type='lease' hideUpload={lease?.state?.status === 'inactive'} onAgreementCreated={getLease} />
      </div>
      <div class="row">
        <Events id={lease?.id} type='lease' refresh={refresh} locked={lease?.state?.status === 'inactive'} />
      </div>
      <Addons lease={lease} callback={() => getLease()} />
      <Modal isOpen={modal} onRequestClose={() => setModal(false)} className='no-padding'>
        <Card
          collapsed={null}
          title={lease.stop !== null ? 'Justera slutdatum' : 'Avsluta uthyrning'}
          icon='fas fa-fw fa-calendar-times'
          buttons={{
            header: [{ callback: () => setModal(false), text: 'Avbryt', bg: 'light', icon: 'fas fa-times' }],
            footer: [
              {
                callback: () => patch('stop', endDate),
                text: 'Spara',
                disabled: unreturnedQuittances > 0,
                title: unreturnedQuittances > 0 ? `${unreturnedQuittances} kvittenser måste återlämnas först` : ''
              },
              {
                callback: () => patch('stop', null),
                text: 'Återgå till löpande uthyrning',
                bg: 'light',
                hidden: endDate === null || lease.stop === null
              }
            ]
          }}>
          {unreturnedQuittances > 0 && (
            <Help type='danger' icon='fas fa-exclamation-triangle'>
              <p><strong>OBS!</strong> Denna uthyrning har {unreturnedQuittances} oreturnerade kvittenser.</p>
              <p>Alla kvittenser måste återlämnas innan uthyrningen kan avslutas.</p>
            </Help>
          )}
          <div className='mb-3 form-group col'>
            <label>Slutdatum</label>
            <DatePicker
              className='form-control'
              placeholderText='Tillsvidare'
              dateFormat='yyyy-MM-dd'
              value={endDate && date.short(endDate)}
              onChange={_date => setEndDate(date.fixTimezone(_date) / 1000)}
            />
            {error?.data?.stop && (
              <div className='form-inline-error'>
                <i className='fa fa-fw fa-exclamation-triangle' />
                {error.data.stop[0]}
              </div>
            )}
          </div>
        </Card>
      </Modal>
      <Modal isOpen={invoiceMonthModal} onRequestClose={() => setInvoiceMonthModal(false)} className='no-padding'>
        <Card
          collapsed={null}
          title='Justera nästa hyresaviperiod'
          icon='fas fa-fw fa-calendar-times'
          buttons={{
            header: [{ callback: () => setInvoiceMonthModal(false), text: 'Avbryt', bg: 'light' }],
            footer: [
              { callback: () => patch('next_invoice_month', nextInvoiceMonth), text: 'Spara', sending: sending },
              { callback: () => patch('next_invoice_month', null), text: 'Inaktivera automatisk generering', bg: 'light', sending: sending, hidden: lease.next_invoice_month === null }
            ]
          }}>
          <Help type='info'>
            Välj från vilken månad nästa <b>automatiskt uppskapade</b> hyresavi ska gälla ifrån.
            <br />
            <br />
            <a href={`#!/company/${lease?.company?.id}/invoicingconfig`}>Aviseringsinställningarna</a> för företaget är konfigurerade enligt:
            <ul>
              <li>
                Skapa hyresavier den <b>{lease?.company?.invoicingconfig?.generate_day}e</b> varje månad
              </li>
              <li>
                Perioden gäller <b>{lease?.company?.invoicingconfig?.generate_period === 'CURRENT_MONTH' ? 'nuvarande månad' : 'nästkommande månad'}</b>
              </li>
            </ul>
            {(() => {
              const generateDay = lease?.company?.invoicingconfig?.generate_day;
              if (!generateDay) return null;
              const today = moment();
              const generateDateThisMonth = moment().date(generateDay); // set day in current month

              return generateDateThisMonth.isSameOrBefore(today) ? "Då datum för generering (" + generateDay + "e) förekommer på eller tidigare än dagens datum är det först nästkommande månad som perioden kan gälla ifrån" : "Du kan bara välja innevarande månad eller framåt i tiden.";
            })()}
          </Help>
          <div className='mb-3 form-group col'>
            <label>Period börjar</label>
            <DatePicker
              className='form-control'
              placeholderText='Automatisk generering inaktivt för denna uthyrning'
              dateFormat='yyyy-MM'
              showMonthYearPicker
              minDate={getMinSelectableDate()}
              showFullMonthYearPicker
              locale={sv}
              value={nextInvoiceMonth}
              onChange={_date => setNextInvoiceMonth(date.month(_date))}
            />
            {error && error?.data?.next_invoice_month && (
              <div className='form-inline-error'>
                <i className='fa fa-fw fa-exclamation-triangle' />
                {error.data.next_invoice_month[0]}
              </div>
            )}
          </div>
        </Card>
      </Modal>
      <SearchModal
        search={async query =>
          await API.get('api/search', [
            ['query', query],
            ['index', 'tenants']
          ])
        }
        open={searchModal}
        title='Sök fram en befintlig hyresgäst du vill lägga till'
        close={() => setSearchModal(false)}
        callback={(result) => addTenantToLease(result)}
      />
    </>
  )
}
